import { useState } from 'react'

import Sticky from 'app/common/templates-next/sticky'
import { PageTemplateContent, Header2 } from 'app/common/templates-next/page-template'
import { DishId } from 'app/common/types/id'
import { HeaderReturnLink } from 'app/components/common/HeaderReturnLink'
import { ContentGroup } from 'app/common/templates-next/page-template'
import PlainLabel from 'app/common/ui-next/plain-label'
import { PlainInputNumber } from 'app/common/ui-next/plain-input'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { PlainTextArea } from 'app/common/ui-next/plain-text-area'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'
import PlainLink from 'app/common/ui-next/plain-link'

import { DishTechComponentsTable } from './DishTechComponentsTable'
import { parseFormData } from 'app/common/lib/parseFormData'
import { Field, FormDataParsed } from './types'
import { PhotoSelector } from './PhotoSelector'
import styles from './DishTechCard.module.scss'

export const DishTechCard = ({
  dishId,
  homeLink,
  writeAccess, // TODO
}: {
  dishId: DishId
  homeLink: string
  writeAccess: boolean
}) => {
  const [proteins, setProteins] = useState('')
  const [fats, setFats] = useState('')
  const [carbohydrates, setCarbohydrates] = useState('')
  const [caloric, setCaloric] = useState('')
  const [technology, setTechnology] = useState('')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const data = parseFormData<FormDataParsed>(new FormData(e.currentTarget as HTMLFormElement))
    console.log(data)
  }

  return (
    <>
      <Sticky>
        {(ref) => (
          <PageTemplateContent className={styles.headerContainer} reference={ref} horizontalLayout>
            <Header2 skipMargin className={styles.header}>
              {'Тех карта «...»'}
            </Header2>
            <PlainLink to="#">
              <PlainIcon
                className={styles.iconDownload}
                type={iconType.DOWNLOAD}
                color={iconColor.COLOR_PRIMARY}
              />
            </PlainLink>
            <div className={styles.headerSpace} />
            <HeaderReturnLink to={homeLink}>{'Вернуться к списку продукции'}</HeaderReturnLink>
          </PageTemplateContent>
        )}
      </Sticky>
      <PageTemplateContent className={styles.root}>
        <form id="dishTechCardForm" onSubmit={handleSubmit}>
          <div className={styles.mainLayout}>
            <div className={styles.innerLayout}>
              <ContentGroup>
                <div className={styles.info}>{'* Поля обязательные к заполнению'}</div>

                <DishTechComponentsTable />
              </ContentGroup>

              <ContentGroup header="Пищевые вещества" normalHeader>
                <div className={styles.kbzhuLayout}>
                  <div className={styles.ordinalItem}>
                    <PlainLabel htmlFor={Field.Proteins} skipUpperSpace displayAsBlock>
                      {'Белки, г*'}
                    </PlainLabel>
                    <PlainInputNumber
                      id={Field.Proteins}
                      name={Field.Proteins}
                      value={proteins}
                      onValue={setProteins}
                      step="0.01"
                      wide
                    />
                  </div>
                  <div className={styles.ordinalItem}>
                    <PlainLabel htmlFor={Field.Fats} skipUpperSpace displayAsBlock>
                      {'Жиры, г*'}
                    </PlainLabel>
                    <PlainInputNumber
                      id={Field.Fats}
                      name={Field.Fats}
                      value={fats}
                      onValue={setFats}
                      step="0.01"
                      wide
                    />
                  </div>
                  <div className={styles.ordinalItem}>
                    <PlainLabel htmlFor={Field.Carbohydrates} skipUpperSpace displayAsBlock>
                      {'Углеводы, г*'}
                    </PlainLabel>
                    <PlainInputNumber
                      id={Field.Carbohydrates}
                      name={Field.Carbohydrates}
                      value={carbohydrates}
                      onValue={setCarbohydrates}
                      step="0.01"
                      wide
                    />
                  </div>
                  <div className={styles.caloricItem}>
                    <PlainLabel htmlFor={Field.Caloric} skipUpperSpace displayAsBlock>
                      {'Калорийность, ккал*'}
                    </PlainLabel>
                    <PlainInputNumber
                      id={Field.Caloric}
                      name={Field.Caloric}
                      value={caloric}
                      onValue={setCaloric}
                      step="0.01"
                      wide
                    />
                  </div>
                </div>
              </ContentGroup>
            </div>

            <div>
              <PlainLabel htmlFor={Field.Technology} skipUpperSpace displayAsBlock>
                {'Технология приготовления'}
              </PlainLabel>
              <PlainTextArea
                rows={5}
                id={Field.Technology}
                name={Field.Technology}
                value={technology}
                onChange={(e) => setTechnology(e.currentTarget.value)}
              />
            </div>

            <div>
              <PlainLabel htmlFor={Field.Photo} skipUpperSpace>
                {'Добавить фото'}
              </PlainLabel>
              <PhotoSelector
                id={Field.Photo}
                description="Загрузить фото"
                linkText="+ Загрузить"
                deleteMessage="Удалить фото"
                // photoUrl={defaultData?.photo || undefined}
                // locked={disabled || loading}
              />
            </div>

            <ControlsBar right>
              <PlainButton outline>{'Отмена'}</PlainButton>
              <PlainButton type="submit">{'Сохранить'}</PlainButton>
            </ControlsBar>
          </div>
        </form>
      </PageTemplateContent>
    </>
  )
}
